import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CtaButton } from '../cta-button/cta-button';
import { OptionChip } from '../option-chip/option-chip';
import { PillBadge } from '../pill-badge/pill-badge';
import { BotChatCardType, CTAButtonVariant, OptionChipMode } from '@/shared/enums';
import { BotChatOption, OrderSummaryItem, TimeSlotGroup } from '@/shared/interfaces';
import { MarkdownPipe } from '@/shared/pipes';

@Component({
  selector: 'bevvi-bot-chat-card',
  imports: [CurrencyPipe, CtaButton, OptionChip, PillBadge, MarkdownPipe],
  templateUrl: './bot-chat-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BotChatCard {
  public readonly type = input<BotChatCardType>(BotChatCardType.MESSAGE);
  public readonly title = input('');
  public readonly description = input('');
  public readonly badge = input('');
  public readonly options = model<BotChatOption[]>([]);
  public readonly multiselect = input(false);
  public readonly orderItems = input<OrderSummaryItem[]>([]);
  public readonly totalAmount = input(0);
  public readonly slotGroups = input<TimeSlotGroup[]>([]);
  public readonly primaryButtonText = input('Submit');
  public readonly secondaryButtonText = input('No');
  public readonly showActions = input(false);

  public readonly disabled = input(false);

  public readonly submitClick = output<void>();
  public readonly secondaryClick = output<void>();
  public readonly optionChange = output<BotChatOption[]>();

  protected readonly optionChipMode = OptionChipMode;
  protected readonly CTAButtonVariant = CTAButtonVariant;

  public toggleOption(optionId: string): void {
    if (this.disabled()) return;
    const isMulti = this.multiselect() || this.type() === BotChatCardType.MULTISELECT;
    const updatedOptions = this.options().map((option) => {
      if (isMulti) {
        return option.id === optionId ? { ...option, selected: !option.selected } : option;
      }
      return { ...option, selected: option.id === optionId };
    });

    this.options.set(updatedOptions);
    this.optionChange.emit(updatedOptions);
  }
}
